// Init
import axios from 'axios';
import { toast } from 'react-toastify';
import { baseUrl, nodeUrl } from '../config';

const api = async (method = 'get', uri, body, chart) => {
  // API Call
  const url = chart ? nodeUrl + uri : baseUrl + uri;
  const token = localStorage.getItem('token');
  if (token) {
    axios.defaults.headers = {
      Authorization: `Bearer ${token}`,
    };
  }

  return new Promise((resolve, reject) => {
    axios[method](url, body)
      .then((res) => {
        if (res.data.success) {
          resolve(res);
        } else {
          console.log('API Error --------> ', res);
          console.log(res?.data?.errorMessage.length, 'jd');
          const errors = Object.values(res?.data?.errors ?? {});
          const error =
            errors?.[0]?.[0]?.length > 0
              ? errors?.[0]?.[0]
              : res?.data?.errorMessage.length == 1
              ? res?.data?.errorMessage[0]
              : 'Something bad happened';
          //const error = errors?.[0]?.[0]?.length > 0 ? errors?.[0]?.[0] : "Something bad happened";
          toast.error(error);
          reject(res);
        }
      })
      .catch((err) => {
        console.log('API Error CATCH ->', err);
        toast.error(`Pas d'Internet`);
        reject(err);
      });
  });
};

// Export
export default api;
